import { app } from '../../../../../app';
import { Controller } from './fido-add.controller';

app.component('addFidoTokens', {
   // bindings: {close: '&', dismiss: '&', resolve: '<'},
   // bindings: { companyId: '<'},
    controller: Controller,
    templateUrl: require('./fido-add.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-add/fido-add/fido-add.component.js